import { useState } from 'react';
import { GlobalButton, SelectMultiInput, TextInput } from '@/components';
import { InboxFilter, InboxStatus } from '../models';
import {
  DeleteForever as TrashIcon,
  Search as SearchIcon,
} from '@mui/icons-material';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';

interface SearchBarProps {
  initialFilter: InboxFilter;
  filter: InboxFilter;
  search: (filters: InboxFilter) => void;
}

const inboxStatuses = [
  { label: 'Pendiente', value: 'PENDING' },
  { label: 'Atendiendo', value: 'ATTENDING' },
  { label: 'No Entregado', value: 'FINALIZED_NOT_DELIVERED' },
  { label: 'Entregado', value: 'FINALIZED_DELIVERED' },
  { label: 'Aún no confirmado', value: 'SCHEDULED_PENDING' },
];

const SearchBar = ({ initialFilter, filter, search }: SearchBarProps) => {
  const [localFilter, setLocalFilter] = useState<InboxFilter>(filter);

  const resetFilters = () => {
    setLocalFilter(initialFilter);
    search(initialFilter);
  };

  const handleSearch = () => search(localFilter);

  return (
    <div className='w-full p-5 flex flex-col justify-center bg-white rounded-lg shadow-md gap-5'>
      <div className='flex gap-2.5'>
        <TextInput
          name='shipping-id-search'
          placeholder='Pedido'
          value={localFilter.shippingId}
          onChange={(value) => {
            setLocalFilter({
              ...localFilter,
              shippingId: value.toString(),
            });
          }}
        />
        <TextInput
          name='document-number-search'
          placeholder='Documento'
          value={localFilter?.documentNumber}
          onChange={(value) => {
            setLocalFilter({
              ...localFilter,
              documentNumber: value.toString(),
            });
          }}
        />
      </div>
      <div className='flex gap-2.5'>
        <SelectMultiInput
          name='statuses-search'
          placeholder='Estados'
          options={inboxStatuses}
          value={localFilter.statuses}
          onChange={(value) => {
            setLocalFilter({
              ...localFilter,
              statuses: value as InboxStatus[],
            });
          }}
        />
        <TextInput
          name='telephone-number-search'
          placeholder='Celular'
          value={localFilter?.phoneNumber}
          onChange={(value) => {
            setLocalFilter({
              ...localFilter,
              phoneNumber: value.toString(),
            });
          }}
        />
      </div>
      <div className='flex gap-2 justify-end'>
        <GlobalButton
          variant={GlobalButtonVariant.secondaryButton}
          action={resetFilters}
        >
          <TrashIcon color={'primary'} />
          Limpiar
        </GlobalButton>
        <GlobalButton
          variant={GlobalButtonVariant.secondaryButton}
          action={handleSearch}
        >
          <SearchIcon color={'primary'} />
          Buscar
        </GlobalButton>
      </div>
    </div>
  );
};

export default SearchBar;
